import React from "react";
import { connect } from "react-redux";
//import { I18n } from "aws-amplify";
import { get, map, flatten, isEmpty, filter } from "lodash";

import FormSection from "../Common/FormSection";

const SitesFilter = (props) => {
  const { user, formValue, setFormValue } = props;
  const [companies, setCompanies] = React.useState();

  React.useEffect(() => {
    setCompanies(get(user, ["companies"]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!isEmpty(companies) && props.defaultSelectAll) {
      // Default select all
      // setFormValue("sites", null, [
      //   -1,
      //   ...map(flatten(map(companies, (c) => get(c, ["sites"]))), (s) =>
      //     get(s, ["id"])
      //   ),
      // ]);
      setFormValue(
        "sites",
        null,
        map(flatten(map(companies, (c) => get(c, ["sites"]))), (s) =>
          get(s, ["id"])
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companies]);

  let options = [
    // { noCategory: true, options: [{ id: -1, name: I18n.get("site_noSite") }] },
    ...map(companies, (c) => ({ ...c, options: get(c, ["sites"]) })),
  ];

  return (
    <FormSection
      formValue={formValue}
      setFormValue={(id, index, value) =>
        props.singleSelect
          ? setFormValue(id, index, value)
          : setFormValue(
              id,
              index,
              filter(value, (v) => v !== undefined)
            )
      }
      title={"sites"}
      id={"sites"}
      type="select"
      options={{
        selectAll: true,
        multipleSelect: props.singleSelect ? false : true,
        categories: true,
        clickThrough: true,
        options: options,
      }}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(SitesFilter);
